'use client'

import { Box, Grid2 as Grid, Typography } from '@mui/material'

// Types
import type { CustomerItemProps } from '@/types/components/molecules/items/customer'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Utils
import ToPersianNumber from '@/utils/to-persian-number'

const CustomerItemMolecule = (props: CustomerItemProps) => {
	// Props
	const { text, image, year } = props

	// Varaibles
	const { t } = useTranslation()

	return (
		<Grid
			container
			alignItems="center"
			justifyContent="center"
			flexWrap={{ xs: 'nowrap', md: 'wrap' }}
			bgcolor={{ xs: '#e8e8e8', md: 'inherit' }}
			sx={{
				cursor: 'pointer',
				borderTopRightRadius: { xs: 35, md: 127 },
				borderTopLeftRadius: { xs: 50, md: 127 },
				borderBottomRightRadius: { md: 64 },
				borderBottomLeftRadius: { xs: 50, md: 'inherit' },
				transition: 'all .3s ease-in-out',
				'.selected &, &:hover': {
					bgcolor: '#f0e5ff',
					'& .customer-image': {
						bgcolor: 'common.white',
						filter: 'grayscale(0%)'
					},
					'& .MuiTypography-root': {
						visibility: 'visible',
						opacity: 100,
						color: '#af73ff'
					}
				}
			}}
		>
			<Grid width={{ xs: 105, md: 172 }} height={{ xs: 105, md: 172 }} p={0.75}>
				<Box
					className="customer-image"
					height={1}
					p={1}
					bgcolor={{ xs: 'common.white', md: '#e8e8e8' }}
					borderRadius={20}
					overflow="hidden"
					sx={{
						filter: 'grayscale(0%)',
						transition: 'all .3s ease-in-out',
						'& picture': {
							display: 'inline-flex',
							width: 1,
							height: 1,
							borderRadius: 20,
							overflow: 'hidden',
							'& img': {
								width: 1,
								height: 1,
								objectFit: 'cover',
								objectPosition: 'center'
							}
						}
					}}
				>
					<picture>
						<img src={image} alt={t(text ?? '')} />
					</picture>
				</Box>
			</Grid>

			<Grid size={{ xs: 6, sm: 7, md: 12 }} ml={{ xs: 0.5, md: 'inherit' }} p={0.7}>
				<Grid container justifyContent="center" minHeight={64}>
					{text && (
						<Grid size={12} minHeight={1.5}>
							<Typography
								variant="h5"
								maxHeight={45}
								fontSize={15}
								fontWeight={700}
								lineHeight={1.5}
								letterSpacing={-0.7}
								textAlign={{ md: 'center' }}
								color="common.black"
								textOverflow="ellipsis"
								overflow="hidden"
								sx={{
									WebkitBoxOrient: 'vertical',
									boxOrient: 'vertical',
									WebkitLineClamp: 2,
									lineClamp: 2,
									transition: 'all .3s ease-in-out'
								}}
							>
								{t(text)}
							</Typography>
						</Grid>
					)}

					{year && (
						<Grid className="customer-year" size={12}>
							<Typography
								variant="body2"
								visibility={{ md: 'hidden' }}
								fontSize={{ xs: 15, md: 13 }}
								fontWeight={400}
								lineHeight={1.5}
								letterSpacing={-0.7}
								textAlign={{ md: 'center' }}
								color="common.black"
								sx={{
									opacity: { md: 0 },
									transition: 'all .3s ease-in-out'
								}}
							>
								{ToPersianNumber(t(year.toString()))}
							</Typography>
						</Grid>
					)}
				</Grid>
			</Grid>
		</Grid>
	)
}

export default CustomerItemMolecule
